import { flagByCurrency } from '@/constants/countries'
import { Currency } from '@/constants/currency'
import { getFlagUrl } from '@/lib/images'
import { formatCurrency } from '@/lib/money'
import {
  MotionSpan,
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/shared/ui'

const CURRENCY_PAIRS: CurrencyPair[] = [
  {
    currencyIn: Currency.USDC,
    currencyOut: Currency.MXN,
  },
  {
    currencyIn: Currency.EURC,
    currencyOut: Currency.MXN,
  },
  {
    currencyIn: Currency.USDC,
    currencyOut: Currency.EURC,
  },
]

type Props = {
  currencyIn: Currency
  currencyOut: Currency
  onSelect?: (currencies: CurrencyPair) => void
}

type CurrencyPair = {
  currencyIn: Currency
  currencyOut: Currency
}

export const FxRatesSelect = ({ currencyIn, currencyOut, onSelect }: Props) => {
  const handleSelect = (value: string) => {
    if (!onSelect) return

    const [currencyIn, currencyOut] = value.split('x').map((c) => c.trim()) as [
      Currency,
      Currency,
    ]
    onSelect({ currencyIn, currencyOut })
  }

  const renderCurrencyPair = (currencyIn: Currency, currencyOut: Currency) => (
    <span className="flex items-center gap-2">
      <span className="relative h-8 w-5 shrink-0">
        <span className="absolute top-1.5 left-0">
          <img
            src={getFlagUrl(flagByCurrency[currencyIn])}
            className="size-3 rounded-full border border-white"
            alt=""
            aria-hidden
          />
        </span>
        <span className="absolute top-3.5 left-1.5">
          <img
            src={getFlagUrl(flagByCurrency[currencyOut])}
            className="size-3 rounded-full border border-white"
            alt=""
            aria-hidden
          />
        </span>
      </span>
      <span className="text-neutral-gray-900 flex items-center gap-1">
        {formatCurrency(currencyIn)}
        <span>x</span>
        {formatCurrency(currencyOut)}
      </span>
    </span>
  )

  return (
    <Select value={`${currencyIn}x${currencyOut}`} onValueChange={handleSelect}>
      <SelectTrigger className="bg-neutral-gray-100 h-8 min-w-42">
        <SelectValue>
          <MotionSpan key={`${currencyIn}x${currencyOut}`}>
            {renderCurrencyPair(currencyIn, currencyOut)}
          </MotionSpan>
        </SelectValue>
      </SelectTrigger>
      <SelectContent>
        {CURRENCY_PAIRS.map((pair) => (
          <SelectItem
            disabled={
              pair.currencyIn === currencyIn && pair.currencyOut === currencyOut
            }
            key={`${pair.currencyIn}x${pair.currencyOut}`}
            value={`${pair.currencyIn}x${pair.currencyOut}`}
          >
            {renderCurrencyPair(pair.currencyIn, pair.currencyOut)}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  )
}
